import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../redux/slices/authSlice';

const AdminLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, error: reduxError, isAdminLoggedIn } = useSelector((state) => state.auth);

    useEffect(() => {
        if (isAdminLoggedIn) {
            navigate('/admin-dashboard', { replace: true });
        }
    }, [isAdminLoggedIn, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            await dispatch(adminLogin({ email, password })).unwrap();
            // Do not navigate here, wait for isAuthenticated in useEffect
        } catch (err) {
            setError(err?.message || 'Invalid email or password');
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">Admin Login</h2>

                {(error || reduxError) && (
                    <div className="bg-red-100 text-red-700 p-3 rounded mb-4">
                        {typeof (error || reduxError) === 'string'
                            ? (error || reduxError)
                            : (error || reduxError)?.message}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter your email"
                            required
                        />
                    </div>
                    <div className="mb-6">
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter your password"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className={`w-full py-2 px-4 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${loading ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>

                {loading && (
                    <p className="mt-4 text-center text-sm text-blue-500">
                        Please wait, logging in...
                    </p>
                )}

                <p className="mt-4 text-center text-sm text-gray-600">
                    Forgot password?{' '}
                    <a href="/forgot-password" className="text-blue-600 hover:underline">
                        Reset here
                    </a>
                </p>
            </div>
        </div>
    );
};

export default AdminLogin;
